import axios from 'axios'
import { APP_API_BASE } from '@/utils/api-base'

const publicRequest = axios.create({
  baseURL: APP_API_BASE,
  timeout: 15000
})

function unwrap(res) {
  const body = res && res.data
  if (!body) {
    return Promise.reject(new Error('网络异常'))
  }
  if (body.status != null && Number(body.status) !== 200) {
    return Promise.reject(new Error(body.msg || body.message || '请求失败'))
  }
  return body.data
}

/** 公开库存看板分页（对齐 H5 管理端库存一览） */
export function fetchPublicSealStockBoard(params) {
  return publicRequest
    .get('/signstore/public/sealStock/board', { params })
    .then(unwrap)
}

/** 筛选下拉：规则 / 底座 / 手柄 / 渠道 */
export function fetchPublicSealStockOptions(token) {
  return publicRequest
    .get('/signstore/public/sealStock/options', { params: { token } })
    .then(unwrap)
}

/** 物料入出库详情 */
export function fetchPublicSealSkuMovements(token, id) {
  return publicRequest
    .get('/signstore/public/sealStock/skus/' + id + '/movements', { params: { token } })
    .then(unwrap)
}
